namespace Matrix.Data {
    export class TestResultMuteColumns {
        static columnsKey = 'Data.TestResultMute';
    }
}
